import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ComparisonFilter from './single-comparison-filter';

class ComparisonFilterContainer extends Component {
  render() {
    const { comparisonDateRanges } = this.props;

    const comparisonFilters = comparisonDateRanges.map(cdr => (
      <ComparisonFilter
        key={cdr.comparisonId}
        comparisonId={cdr.comparisonId}
        isDeletable={cdr.comparisonId !== 1}
        isAdvancedFilter
      />
    ));

    return (
      <div>
        {comparisonFilters}
      </div>
    );
  }
}

ComparisonFilterContainer.propTypes = {
  comparisonDateRanges: PropTypes.array,
};

ComparisonFilterContainer.defaultProps = {
  comparisonDateRanges: [],
};

export default ComparisonFilterContainer;
